/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatusLabel } from './StatusLabel';
import {
    StatusLabelFromJSON,
    StatusLabelFromJSONTyped,
    StatusLabelToJSON,
} from './StatusLabel';

/**
 * 
 * @export
 * @interface ToDoItemStatus
 */
export interface ToDoItemStatus {
    /**
     * 
     * @type {StatusLabel}
     * @memberof ToDoItemStatus
     */
    label: StatusLabel;
    /**
     * 
     * @type {number}
     * @memberof ToDoItemStatus
     */
    days: number;
}

/**
 * Check if a given object implements the ToDoItemStatus interface.
 */
export function instanceOfToDoItemStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "days" in value;

    return isInstance;
}

export function ToDoItemStatusFromJSON(json: any): ToDoItemStatus {
    return ToDoItemStatusFromJSONTyped(json, false);
}

export function ToDoItemStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToDoItemStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': StatusLabelFromJSON(json['Label']),
        'days': json['Days'],
    };
}

export function ToDoItemStatusToJSON(value?: ToDoItemStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Label': StatusLabelToJSON(value.label),
        'Days': value.days,
    };
}

